<template>
    <div>
      <base-dialog-full ref="refBaseDialogFull"
                        :show="true"
                        :tempSaveBtn="isTempSaveBtn"
                        :title="title"
                        @close="closeHandler"
                        @save="saveHandler">
        <router-view ref="refProposalTabs"
                      @go-top="goTop"
                      @set-title="setTitle"
                      @temp-btn-hide="tempBtnHide"></router-view>
      </base-dialog-full>
    </div>
  </template>

  <script>
  import { includes } from 'lodash'
  import ProposalBase from './ProposalBase'
  export default {

    extends: ProposalBase,

    props: {
      transCode:{
        type: String
      },
      isPreview: {
        // 是否為檢視模式
        type: Boolean,
        default: false
      },
      pChangeYn: {
        // 資料是否異動
        type: String,
        default: 'N'
      },
      pSignedYn: {
        // 簽名是否存在
        type: String,
        default: 'N'
      },
      compCode:{ //公司代碼
        type: String,
      },
      routerPage: { // 指定要去的頁面
        type: String,
      },
      polInsureType :{ // 案件類型  編輯時傳遞
        type: String,
      },
    },

    data () {
      return {
        title: '要保書建置',
        polKind: null,
        routerFrom: null,
        excludSaveBtnTabIndex: ['n5'], // 排除暫存
        isTempSaveBtn: true
      }
    },

    computed: {
      /*
      title (){
        //TODO 公司名稱
        return this.compCode ? '要保書建置-' + this.compCode : '要保書建置'
      }
      */
    },

    watch: {
    },

    beforeRouteEnter (to, from, next) {
      if (!to.params.notReloadAction) {
        if (to.params.enterpoint) {
          next({ name: to.params.enterpoint })
        } else {
          next(from)
        }
      } else {
        next(vm => {
          vm.routerFrom = from
        })
      }
    },

    created () {
      document.documentElement.className = 'hide-scrollbar'
      const { transCode } = this
      let params
          params = { ...this.$props, propKey: {
            transCode: transCode
          }
        }
      this.$router.replace({ name: 'proposalRemoteSteps', params })
    },

    beforeDestroy () {
      document.documentElement.className = '' // 關閉 html scrollbar
    },

    methods: {
      setTitle (v) {
        this.title = v
      },
      goTop () {
        this.$refs['refBaseDialogFull'].scrollTop()
      },
      closeHandler () {
        const tabRef = this.$refs['refProposalTabs']
        tabRef && tabRef.close && tabRef.close()
        // this.$confirm('是否確認離開此要保書建置？').then(yn => {
        //   if (yn) {
        //     console.log(this.transCode)
        //     const progClassName = `QuitInsS${this.tabStep}`
        //     this.$postUserAccessLog({ progClassName, methodName: '退出', stepCode: this.tabStep, transCode: this.transCode })
        //     this.leave()
        //   }
        // })
      },
      tempBtnHide(currentStep,isPreview) { // 排除特定頁籤步顯示暫存按鈕
        const {excludSaveBtnTabIndex } = this
        this.isTempSaveBtn = !(isPreview || excludSaveBtnTabIndex.includes(currentStep))
      },
      saveHandler () { // 暫存
        const tabRef = this.$refs['refProposalTabs']
        tabRef && tabRef.tempSave && tabRef.tempSave()
      },
      leave () {
        this.$router.replace({ name: 'proposal' })
      }
    }
  }
  </script>
